import { LOGIN, LOGOUT } from "../actions/types";

const INITIAL_STATE = {
    token: null,
    userID: null
};

const authReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                token: action.payload.token,
                userID: action.payload.userID
            };
        case LOGOUT:
            return {
                ...state,
                token: null,
                userID: null
            };
        default:
            return state;
    }
};

export default authReducer;